import { useCallback, useState } from 'react';
import { planVariableTypeChange } from '../../../../utils/variableTypeChange';

/** Apply a type change, or hold it until the user confirms value-clear. */
export default function useVariableTypeChange(onPatch) {
  const [pendingTypeChange, setPendingTypeChange] = useState(null);

  const applyTypeChange = useCallback(
    (scope, variable, next) => {
      const patch = { ...next };
      delete patch.id;
      delete patch.name;
      delete patch.scope;
      delete patch.sourceId;
      delete patch.sourceName;
      delete patch.shadowed;
      onPatch(scope, variable.id, patch, { silent: false });
    },
    [onPatch]
  );

  const handleTypeChange = useCallback(
    (scope, variable, nextType) => {
      const plan = planVariableTypeChange(variable, nextType);
      if (plan.next === variable) return;
      if (plan.needsConfirm) {
        setPendingTypeChange({ scope, variable, next: plan.next, message: plan.message });
        return;
      }
      applyTypeChange(scope, variable, plan.next);
    },
    [applyTypeChange]
  );

  return {
    pendingTypeChange,
    setPendingTypeChange,
    applyTypeChange,
    handleTypeChange,
  };
}
